import type { HTMLProps } from 'react';

import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Header } from 'src/apps/header/Header';
import { RouteLoadingSpinner, SomethingWentWrong } from 'src/components';
import { cn } from 'src/utils/classNamesHelper';

function Wrapper({ children, className, ...props }: HTMLProps<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'flex min-h-screen w-full animate-fade-in flex-col items-center justify-center',
        className
      )}
      {...props}
    >
      <div className="w-full">
        <Header variant="minimal" />
      </div>
      <div className="mt-64 flex w-full grow items-center justify-center lm:mt-0">
        {children}
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_auth/_only-header')({
  wrapInSuspense: true,
  errorComponent: ({ error }) => (
    <Wrapper>
      <SomethingWentWrong error={error} />
    </Wrapper>
  ),
  pendingComponent: () => (
    <Wrapper>
      <RouteLoadingSpinner />
    </Wrapper>
  ),
  component: () => (
    <Wrapper>
      <Outlet />
    </Wrapper>
  ),
});
